"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectSchema = exports.botSelectSchema = exports.userSelectSchema = void 0;
const zod_1 = require("zod");
const base_1 = require("../base");
const selectBaseSchema = zod_1.z.object({
    kind: zod_1.z.literal("select"),
    title: zod_1.z.string().nullish(),
    question: zod_1.z.string().nullish(),
    options: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.string().optional(),
        text: zod_1.z.string(),
        description: zod_1.z.string().nullish(),
        icon: zod_1.z.string().nullish(),
    })),
    preserveOrder: zod_1.z.boolean().optional(),
    multiple: zod_1.z.boolean().optional(),
    // todo: picker should only be used with 'multiple: false'
    displayMode: zod_1.z.enum(["list", "grid", "picker"]).optional(),
    imageURL: zod_1.z.string().optional(),
});
exports.userSelectSchema = zod_1.z
    // Note: in theory there is no select from: user
    .object({ assessment: zod_1.z.null() })
    .merge(selectBaseSchema)
    .merge(base_1.sessionInteractionBaseSchema.extend({ from: zod_1.z.literal("user") }));
exports.botSelectSchema = selectBaseSchema.merge(base_1.sessionInteractionBaseSchema.extend({ from: zod_1.z.enum(["bot", "system"]) }));
exports.selectSchema = zod_1.z.discriminatedUnion("from", [
    exports.userSelectSchema,
    exports.botSelectSchema,
]);
//# sourceMappingURL=select.js.map